var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('div',{staticClass:"ui button",on:{"click":_vm.cancel}},[_vm._v("Cancel")]),_c('div',{staticClass:"ui primary button",on:{"click":_vm.save}},[_vm._v("Save")])])
}
var staticRenderFns = []

export { render, staticRenderFns }